import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  deReferralLetterCopilotQuery as DeReferralLetterCopilotQueryType,
} from "@/modules/patients/detail/referral/services/de/__generated__/deReferralLetterCopilotQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query deReferralLetterCopilotQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    referralLetterCopilot: de_referralLetterCopilot(aiRequestMetadata: $aiRequestMetadata) {
      text
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const deReferralLetterCopilotQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<DeReferralLetterCopilotQueryType>(RelayEnvironment, query, {
    aiRequestMetadata,
  }).toPromise()
}
